import { FC } from 'react'
import styles from './phone-icon.module.scss'

type PhoneIconProps = {}

const PhoneIcon: FC<PhoneIconProps> = ({}) => {
  return (
    <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.08884 11.6203C13.1186 17.0471 14.8856 15.7484 15.6746 15.2411C15.8022 15.1759 18.7229 13.4821 16.9065 11.8477C12.6936 8.05575 13.5484 12.9845 9.55989 9.39555C5.57229 5.80585 11.0491 6.57576 6.83622 2.78421C5.01961 1.14928 3.13743 3.77809 3.06584 3.89214C2.50135 4.60238 1.059 6.19351 7.08884 11.6203Z"
        fill="#EB6E00"
      />
    </svg>
  )
}

export default PhoneIcon
